import { useQueryClient } from "react-query";
import { t } from "@/i18n-js/instance";
import { useCoursesInfiniteQuery } from "@circle-react/components/Courses/Directory/useCoursesInfiniteQuery";
import { useJoinSpace } from "@circle-react/components/Spaces/hooks";
import {
  SPACE_SHOW_REQUEST_KEY,
  useIsOrCanBeCommunityMember,
} from "@circle-react/contexts";
import type { Space } from "@circle-react/types";

export interface JoinCourseProps {
  space: Space;
}

export const JoinCourse = ({ space }: JoinCourseProps) => {
  const { isSubmitting, joinSpace } = useJoinSpace({
    space,
  });
  const { is_private: isPrivate } = space;
  const isOrCanBeCommunityMember = useIsOrCanBeCommunityMember();
  const queryClient = useQueryClient();
  const { refetch } = useCoursesInfiniteQuery();

  const handleJoin = async () => {
    await joinSpace();
    queryClient.removeQueries([SPACE_SHOW_REQUEST_KEY, space.id]);
    void refetch();
  };

  if (space.joined || !isOrCanBeCommunityMember || isPrivate) {
    return null;
  }

  return (
    <button
      type="button"
      className="bg-primary text-darkest disabled:text-light !border-dark hover:bg-secondary focus-visible:outline-secondary w-full rounded-md border px-4 py-2 text-sm font-medium leading-5 transition-colors duration-150 ease-in-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed"
      onClick={handleJoin}
    >
      {t(isSubmitting ? "courses.enrolling" : "courses.enroll")}
    </button>
  );
};
